/**
 * トップページ
 */
'use strict';
import '@/_constant/global';
import Main from '@/_page/main';
window.gAMBR.mods['main'] = new Main();

document.addEventListener('DOMContentLoaded', () => {
  gAMBR.mods['main'].init();
}, false);

window.addEventListener('load', () => {
  console.log('win load');
}, false);

window.addEventListener('unload', () => {}, false);
